module.exports = __webpack_public_path__ + "img/expostyle_0011_dark_green_pantone553c.55b138e7.jpg";